var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSmsNew({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "128px",
    height: "120px",
    viewBox: "0 0 128 120",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "SMS") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "SMS"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-16",
    stroke: "#E7EEF1",
    fill: "#F4F7FC",
    x: 0.5,
    y: 0.5,
    width: 127,
    height: 119,
    rx: 8
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(37, 15)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.19743038,53.8383162 L18.2805555,53.8383162 L29.5425673,63.0637115 L29.5425673,53.8383162 L35.0272361,53.8383162 C36.7904831,53.8383162 38.2247318,52.3738617 38.2247318,50.5745138 L38.2247318,29.2157451 C38.2247318,27.4152012 36.7904831,25.950817 35.0272361,25.950817 L3.19743038,25.950817 C1.43429285,25.950817 0,27.4152012 0,29.2157451 L0,50.5745138 C0,52.3738617 1.43429285,53.8383162 3.19743038,53.8383162 Z M0.606721099,29.2157451 C0.606721099,27.7489336 1.76920387,26.555419 3.19743038,26.555419 L35.0261771,26.555419 C36.4544248,26.555419 37.6168617,27.7489336 37.6168617,29.2157451 L37.6168617,50.5745138 C37.6168617,52.0414308 36.4544248,53.2336087 35.0261771,53.2336087 L28.9346266,53.2336087 L28.9346266,61.7828854 L18.5802898,53.301502 L18.4965576,53.2325534 L3.19743038,53.2325534 C1.76920387,53.2325534 0.606721099,52.0400237 0.606721099,50.5734585 L0.606721099,29.2157451 Z",
    id: "Shape",
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero",
    points: "5.25296684 33.2715419 19.8143156 33.2715419 19.8143156 33.8761791 5.25296684 33.8761791"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero",
    points: "5.25296684 39.4083557 32.970503 39.4083557 32.970503 40.0130632 5.25296684 40.0130632"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero",
    points: "5.25296684 45.5454862 32.970503 45.5454862 32.970503 46.1498419 5.25296684 46.1498419"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#37474F",
    fillRule: "nonzero",
    x: 26.5248205,
    y: 3.16600791,
    width: 6.70704548,
    height: 1.40711462
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.40368405,56.812253 L6.40368405,81.9644269 C6.40368405,85.8501739 9.56457338,89 13.4637319,89 L45.9399521,89 C49.8392166,89 53,85.8501739 53,81.9644269 L53,7.03557312 C53,3.14993162 49.8392166,0 45.9399521,0 L13.4637319,0 C9.56457338,0 6.40368405,3.14993162 6.40368405,7.03557312 L6.40368405,24.4486166",
    id: "Path",
    stroke: "#37474F",
    strokeWidth: 1.4
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmsNew);
export default __webpack_public_path__ + "static/media/SMS_new.af46166e47181195efdf7c0cdf819177.svg";
export { ForwardRef as ReactComponent };